
import { mapState } from 'vuex'
import AccordionSection from '@/components/globals/AccordionSection.vue'
import LocationCard from '@/components/locations/LocationCard.vue'

export default {
  name: 'LocationsAllViewDefault',
  components: {
    AccordionSection,
    LocationCard,
  },
  data() {
    return {
      locations: [],
      stateNames: {
        AL: 'Alabama',
        AK: 'Alaska',
        AS: 'American Samoa',
        AZ: 'Arizona',
        AR: 'Arkansas',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DE: 'Delaware',
        DC: 'District Of Columbia',
        FM: 'Federated States Of Micronesia',
        FL: 'Florida',
        GA: 'Georgia',
        GU: 'Guam',
        HI: 'Hawaii',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        IA: 'Iowa',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        ME: 'Maine',
        MH: 'Marshall Islands',
        MD: 'Maryland',
        MA: 'Massachusetts',
        MI: 'Michigan',
        MN: 'Minnesota',
        MS: 'Mississippi',
        MO: 'Missouri',
        MT: 'Montana',
        NE: 'Nebraska',
        NV: 'Nevada',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NY: 'New York',
        NC: 'North Carolina',
        ND: 'North Dakota',
        MP: 'Northern Mariana Islands',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PW: 'Palau',
        PA: 'Pennsylvania',
        PR: 'Puerto Rico',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VT: 'Vermont',
        VI: 'Virgin Islands',
        VA: 'Virginia',
        WA: 'Washington',
        WV: 'West Virginia',
        WI: 'Wisconsin',
        WY: 'Wyomin',

        // Canadian provinces
        BC: 'British Columbia',
      }
    }
  },
  computed: {
    ...mapState({
      states: state => state.locations.all
    })
  },
  watch: {
    states: {
      immediate: true,
      handler(s) {
        if(s.length > 0) {
          this.getLocations(s)
        }
      }
    }
  },
  methods: {
    getLocations(states) {
      this.locations = states.map(state => {
        let currentState = {
          code: state.code,
          name: this.stateNames[state.code],
          counterLabel: '',
          locations: []
        }
        state.cities.map(city => {
          currentState.locations.push(city.locations)
        });
        currentState.locations = currentState.locations.flat();
        const length = currentState.locations.length;
        currentState.counterLabel = `${length} ${length > 1 ? 'Locations' : 'Location'}`;
        return currentState;
      });
    }
  },
  mounted() {
    this.getLocations(this.states)
  }
}
